export default __webpack_public_path__ + "static/media/minus-small.34370d9b.svg";